export enum InProductTrialsOverlayWindowEventType {
  Default = 'defaultOverlayWindowEvent',
  LearnMore = 'learnMoreOverlayWindowEvent',
  Dismiss = 'dismissOverlayWindowEvent',
  AddModules = 'addModulesOverlayWindowEvent',
  RemoveModules = 'removeModulesOverlayWindowEvent',
}

export class OnInProductTrialsOverlayWindowButtonClick extends CustomEvent<{
  eventType: InProductTrialsOverlayWindowEventType;
}> {
  constructor(eventType: InProductTrialsOverlayWindowEventType) {
    super(InProductTrialsOverlayWindowEventType.Default, {
      detail: {
        eventType: eventType,
      },
      bubbles: true,
      composed: true,
    });
  }
}
